import { SET_WAREHOUSES, FAILED_GET_WAREHOUSES, SET_WAREHOUSE, FAILED_UPDATE_WAREHOUSES, UPDATE_WAREHOUSE, FAILED_GET_WAREHOUSE } from '../constants/warehouseConstants';

const defaultState = {
    warehouses: [],
    errorMessage: null,
};

export const WarehouseReducer = (state = defaultState, { type, errorMessage, warehouses }) => {
    switch (type) {
        case SET_WAREHOUSES:
            return { 
                ...state, 
                warehouses: warehouses
            };
        case FAILED_GET_WAREHOUSES:
            return { 
                ...state, 
                errorMessage: errorMessage 
            };
        case SET_WAREHOUSE:
            return {
                ...state,
                currentWarehouse: warehouses
            };
        case UPDATE_WAREHOUSE:
            return {
                ...state,
                currentWarehouse: warehouses
            };
        case FAILED_UPDATE_WAREHOUSES:
            return {
                ...state,
                errorMessage: errorMessage
            };
        case FAILED_GET_WAREHOUSE:
            return {
                ...state,
                errorMessage: errorMessage
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// src/state/reducers/warehouseReducer.js